import checkPricesConstants from "./constants"

const initialState = {
	emptyReOrgMaterialsPeriodPriceChanges      : null,
	indexesForReOrgMaterialsPeriodPriceChanges : null,
	indexForReOrgMaterialByCategories          : null,
	error                                      : null,
	isSending                                  : false,
	isFileSending                              : false,
	changed                                    : null
}

export default function (state = initialState, action){
	switch (action.type){
		case (checkPricesConstants.GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES.REQUEST):
			return {
				...state,
				changed   : null,
				isSending : true
			}
		case (checkPricesConstants.GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES_FILE.REQUEST):
			return {
				...state,
				isFileSending: true
			}
		case (checkPricesConstants.GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES_FILE.SUCCESS):
		case (checkPricesConstants.GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES_FILE.FAILURE):
			return {
				...state,
				isFileSending: false
			}
		case (checkPricesConstants.GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES.SUCCESS):
			return {
				...state,
				emptyReOrgMaterialsPeriodPriceChanges : action.payload.result,
				isSending                             : false
			}
		case (checkPricesConstants.GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES.FAILURE):
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		case (checkPricesConstants.GET_INDEXES_FOR_REORG_MATERIALS_PERIOD_PRICE.REQUEST):
			return {
				...state,
				indexesForReOrgMaterialsPeriodPriceChanges : null,
				isSending                                  : true
			}
		case (checkPricesConstants.GET_INDEXES_FOR_REORG_MATERIALS_PERIOD_PRICE.SUCCESS):
			return {
				...state,
				indexesForReOrgMaterialsPeriodPriceChanges : action.payload.result,
				isSending                                  : false
			}
		case (checkPricesConstants.GET_INDEXES_FOR_REORG_MATERIALS_PERIOD_PRICE.FAILURE):
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		case (checkPricesConstants.CALCULATE_INDEX_FOR_REORG_MATERIAL_BY_CATEGORIES.REQUEST):
			return {
				...state,
				indexForReOrgMaterialByCategories : null,
				isSending                         : true
			}
		case (checkPricesConstants.CALCULATE_INDEX_FOR_REORG_MATERIAL_BY_CATEGORIES.SUCCESS):
			return {
				...state,
				indexForReOrgMaterialByCategories : action.payload.result,
				isSending                         : false
			}
		case (checkPricesConstants.CALCULATE_INDEX_FOR_REORG_MATERIAL_BY_CATEGORIES.FAILURE):
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		case (checkPricesConstants.ADD_RESULT_FOR_EMPTY_REGION_DATA.REQUEST):
			return {
				...state,
				changed   : null,
				isSending : true
			}
		case (checkPricesConstants.ADD_RESULT_FOR_EMPTY_REGION_DATA.SUCCESS):
			return {
				...state,
				changed   : action.payload.result ? "Сведения успешно добавлены." : null,
				isSending : false
			}
		case (checkPricesConstants.ADD_RESULT_FOR_EMPTY_REGION_DATA.FAILURE):
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		default:
			return state
	}
}